import React from "react";
import { Image } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

const About = () => {
  const bgAbout = {
    backgroundImage: "url('about.png')",
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    color: "#000",
  };
  const { t } = useTranslation();
  // const bgAboutTheme = {
  //   backgroundImage: "url('')",
  //   backgroundSize: "cover",
  //   backgroundPosition: "center",
  //   backgroundRepeat: "no-repeat",
  //   color: "#000",
  //   backgroundColor: " rgb(238, 238, 238)",
  // };

  return (
    <div className="about-content mt-5">
      <Image src="/logo-theme.png" alt="logo-theme" className="about-logo" />
      <section className="" data-aos="fade-up">
        <div className="container text-center">
          <div className="row justify-content-center">
            <div className="col-lg-10">
              <div className="p-32px">
                <div className="mb-3 mb-lg-5" data-aos="fade-right">
                  <h6 className="txt-theme">{t("about_us")}</h6>
                  <h2 className="fw-bold txt-gray-dark">
                    {t("serve")}
                  </h2>
                </div>
                <p className="mb-3">
                  {t("about_home")}
                </p>
                <div className="mt-4">
                  <Link to="/about/patsanstha" className="download-btn bg-secondary-theme">
                    <span>{t("learn_more")}</span>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section>
        <div className="container">
          <div className="row justify-content-center text-center">
            <div className="col-lg-10">
              <div className="row p-32px shadow rounded-3" style={bgAbout}>
                <div
                  className="col-md-6 col-lg-4"
                  data-aos="fade-up"
                  data-aos-duration="1000"
                >
                  <div className="">
                    <div className="about-div position-relative">
                      <img src="community.png" alt="Icon" />
                    </div>
                    <h2 className="mb-3 fw-bold fs-3 text-white">76347</h2>
                    <h5 className="text-white text-uppercase font-weight-600 font-16">
                      {t("memberNumber")}
                    </h5>
                  </div>
                </div>
                <div
                  className="col-md-6 col-lg-4"
                  data-aos="fade-up"
                  data-aos-duration="1000"
                >
                  <div className="">
                    <div className="about-div position-relative">
                      <img src="deposit-amount.png" alt="Icon" />
                    </div>
                    <h2 className="mb-3 fw-bold fs-3 text-white">207 {t("crore")} 66 {t("lakh")}</h2>
                    <h5 className="text-white text-uppercase font-weight-600 font-16">
                      {t("investment_amount")}
                    </h5>
                  </div>
                </div>
                <div
                  className="col-md-6 col-lg-4"
                  data-aos="fade-up"
                  data-aos-duration="1500"
                >
                  <div className="">
                    <div className="about-div position-relative">
                      <img src="deposit-amount.png" alt="Icon" />
                    </div>
                    <h2 className="mb-3 fw-bold fs-3 text-white">
                      777 {t("crore")} 29 {t("lakh")}
                    </h2>
                    <h5 className="text-white text-uppercase font-weight-600 font-16">
                      {t("depositAmount")}
                    </h5>
                  </div>
                </div>
                <div
                  className="col-md-6 col-lg-4"
                  data-aos="fade-up"
                  data-aos-duration="2000"
                >
                  <div className="">
                    <div className="about-div position-relative">
                      <img src="deposit-amount.png" alt="Icon" />
                    </div>
                    <h2 className="mb-3 fw-bold fs-3 text-white">581 {t("crore")} 84 {t("lakh")}</h2>
                    <h5 className="text-white text-uppercase font-weight-600 font-16">
                      {t("loan_amount")}
                    </h5>
                  </div>
                </div>
                <div
                  className="col-md-6 col-lg-4"
                  data-aos="fade-up"
                  data-aos-duration="1500"
                >
                  <div className="">
                    <div className="about-div position-relative">
                      <img src="deposit-amount.png" alt="Icon" />
                    </div>
                    <h2 className="mb-3 fw-bold fs-3 text-white">
                      1359 {t("crore")} 13 {t("lakh")}
                    </h2>
                    <h5 className="text-white text-uppercase font-weight-600 font-16">
                      {t("mix_bussiness")}
                    </h5>
                  </div>
                </div>
                <div
                  className="col-md-6 col-lg-4"
                  data-aos="fade-up"
                  data-aos-duration="2000"
                >
                  <div className="">
                    <div className="about-div position-relative">
                      <img src="shield.png" alt="Icon" />
                    </div>
                    <h2 className="mb-3 fw-bold fs-3 text-white">100 %</h2>
                    <h5 className="text-white text-uppercase font-weight-600 font-16">
                      {t("safeDepositRatio")}
                    </h5>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;
